import React, { lazy, Suspense } from "react";
import LazyLoader from "../../components/common/loader/lazyLoader";
const OrderDetailsAndUpdate = lazy(() =>
  import("../../components/order/orderDetailsAndUpdate")
);

function OrderDtailsAndUpdatePage() {
  return (
    <Suspense fallback={<LazyLoader />}>
      <OrderDetailsAndUpdate />
    </Suspense>
  );
}

export default OrderDtailsAndUpdatePage;
